(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/common/assets/javascripts/accessibility-helpers.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/common/assets/javascripts/accessibility-helpers.js');
"use strict";


const {
  GameRoomStatus
} = svs.bingo_react.components.common.constants;
const getStartTimeString = (timer, status) => {
  if (!timer || status === GameRoomStatus.STARTING) {
    return 'Nästa omgång startar nu. ';
  }
  return "N\xE4sta omg\xE5ng startar om ".concat(timer.minutes > 0 ? 'minuter och ' : '').concat(timer.seconds, " sekunder. ");
};
const getBingoCardAriaLabel = _ref => {
  let {
    title,
    jackpotAmount,
    timer,
    players,
    bingoCardPrice,
    status,
    addTimer
  } = _ref;
  const startTimeString = addTimer ? getStartTimeString(timer, status) : '';
  const playersString = players ? "Antal spelare: ".concat(players, ". ") : '';
  const priceString = bingoCardPrice ? "Pris per bricka: ".concat(bingoCardPrice, " kronor. ") : '';
  const jackpotString = jackpotAmount ? "Jackpot: ".concat(jackpotAmount, " kronor.") : '';
  return "Starta spel: ".concat(title, ". ").concat(startTimeString).concat(playersString).concat(priceString).concat(jackpotString);
};
setGlobal('svs.bingo_react.components.common.accessibilityHelpers', {
  getBingoCardAriaLabel
});

 })(window);